import React from 'react'
import { FRONT, THEME, TRANSLATION } from '../constants/state'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import MovieDetails from './MovieDetails'
import getData from '../functions/getData'

const mapStateToProps = (state, ownProps) => ({
    cinemaDataFront: getData(state, FRONT), 
    translation: getData(state, TRANSLATION),
    theme: getData(state, THEME)
})

const MovieDetailsContainer = ({
    itemID, 
    theme, 
    moviesData, 
    translation, 
    queryStringValues,
    filterType, 
    filterValue,
    backgroundImage, 
    scrollToPosition, 
    isMobile, 
    onCloseDetails,
    trailerImage,
    cinemaDataFront
}) => {

    const {
        attribute_styling,
        details_style
    } = cinemaDataFront

    const {theme_colors} = theme

    return (
        <MovieDetails
            itemID={itemID} 
            theme={theme_colors} 
            moviesData={moviesData} 
            translation={translation} 
            queryStringValues={queryStringValues} 
            filterType={filterType} 
            filterValue={filterValue} 
            backgroundImage={backgroundImage} 
            attributeStyling={attribute_styling} 
            detailsStyling={details_style} 
            scrollToPosition={scrollToPosition} 
            isMobile={isMobile} 
            onCloseDetails={onCloseDetails}
            trailerImage={trailerImage}
        />
    )
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(MovieDetailsContainer)